import { featureFlagKeys, getFeatureFlags } from "../util/general_util";
import { Campground_Data, copilot_err_resp, copilot_success_resp, Trip_Cluster_v2, Trip_v2 } from "../util/tripPlanner_types";
import { addStop_noLoc, getTripHTML, remove_stop, send_addStayToStop,avoidArea } from "./api_utils";
import { clear_highlightedMarker, clearLayer } from "./map/helper_functions";
import { displayStayPins, remove_stay_pin } from "./map/map_displays";
import { display_trip, display_trip_html,display_route } from "./tripPlanner_scripts";
import { display_stop_popout, hide_map_loadingIcon, init_stay_hover_listener, show_map_loadingIcon } from "./ui_utils";
import { add_stay_to_stop } from "./update_trip_utils";
import { get_genieMatches, get_stop_from_stopID, handle_auto_lock, inc_interaction_counter } from "./util/helper_functions";

async function routing_avoid_area(area_query:string) {
    show_map_loadingIcon("")
    const trip:Trip_v2|void = await avoidArea(area_query).catch(e => {
        hide_map_loadingIcon();
        throw new Error("Failed to avoid area");
    });
    if (trip == undefined) {
        hide_map_loadingIcon();
        throw new Error("Failed to avoid area");
    };
    window.tripPlannerCurrentTrip = trip;
    hide_map_loadingIcon();
    display_trip(window.tripPlannerCurrentTrip, true);
};

async function copilot_add_stops(copilot_resp:copilot_success_resp) {
    let respEl;
    let addedStop:boolean = false;
    for (let i:number = 0; i < copilot_resp.arguments["locations"].length; i++ ) {
        const stop_name = copilot_resp.arguments.locations[i];
        show_map_loadingIcon("Adding Stop");
        // $("#copilotGenieBubble").html(`Adding a stop in ${stop_name}`);
        respEl = $("<div>").addClass("message bot").html(`Adding a stop in ${stop_name}`);
        $("#copilot-msg-stream").append(respEl);
        await addStop_noLoc(copilot_resp.arguments["locations"][i]).then(trip => {
            window.tripPlannerCurrentTrip = trip;
            addedStop = true;
        }).catch(e => {
            hide_map_loadingIcon();
            if (e.message == "Maximum Stops allowed for user") {
                let resp:string = "Looks like you've used all your stops.";
                if (window.GAsubLevel == undefined) {
                    resp += "</br>Sign in to your account to add more"
                } else {
                    resp += "</br>Subscribe to add more";
                };
                // $("#copilotGenieBubble").html(resp);
                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);
            };
        });
    };
    if (addedStop) {
        display_trip(window.tripPlannerCurrentTrip, false);
        hide_map_loadingIcon();
        var respMsg:string = "I've added the stop"
        respMsg += (copilot_resp.arguments.locations.length > 1)? "s": ""
        respMsg += " you requested! Is there anything else I can help with?"
        // $("#copilotGenieBubble").html(respMsg);
        respEl = $("<div>").addClass("message bot").html(respMsg);
        $("#copilot-msg-stream").append(respEl);

        inc_interaction_counter();
    }
};

function copilot_handle_reroute(copilot_resp:copilot_success_resp) {
    $('[data-bs-toggle="tab"][href="#tripTab"]').tab("show");
    $('[data-bs-toggle="tab"][href="#routeOptionsTab"]').tab("show");
    if (copilot_resp.arguments.avoid != undefined) {
        if (copilot_resp.arguments.avoid.includes("highway")) {
            $("#avoid-highways").prop("checked", true);
        };
        if (copilot_resp.arguments.avoid.includes("ferry")) {
            $("#avoid-ferries").prop("checked", true);
        };
        if (copilot_resp.arguments.avoid.includes("tunnel")) {
            $("#avoid-tunnels").prop("checked", true);
        };
        if (copilot_resp.arguments.avoid.includes("toll")) {
            $("#avoid-tolls").prop("checked", true);
        };
    };
    if (copilot_resp.arguments.allow != undefined) {
        if (copilot_resp.arguments.allow.includes("highway")) {
            $("#avoid-highways").prop("checked", false);
        };
        if (copilot_resp.arguments.allow.includes("ferry")) {
            $("#avoid-ferries").prop("checked", false);
        };
        if (copilot_resp.arguments.allow.includes("tunnel")) {
            $("#avoid-tunnels").prop("checked", false);
        };
        if (copilot_resp.arguments.allow.includes("toll")) {
            $("#avoid-tolls").prop("checked", false);
        };
    };
    if (copilot_resp.arguments.drive_dist != undefined) {
        let drive_dist:number = copilot_resp.arguments.drive_dist;
        if (drive_dist < 150) drive_dist = 150;
        $("#drive-dist").val(drive_dist);
    };
    $("#recalculate").trigger("click");
};

function get_recommended_camps(stop:Trip_Cluster_v2) {
	// sort by genieMatch
	let recommendedCamps:Campground_Data[] = [...stop.altStops].sort(function(a,b){
		if (a.camp.genieMatch === undefined) {
			var scoreA:number = 0;
		} else {
			var scoreA:number = a.camp.genieMatch;
		};
		if (b.camp.genieMatch === undefined) {
			var scoreB = 0;
		} else {
			var scoreB = b.camp.genieMatch;
		}
		if (Number.isNaN(scoreA)) scoreA = 0;
		if (Number.isNaN(scoreB)) scoreB = 0;

		return scoreB - scoreA;
	}).slice(0,10);
	let topGenieMatch:number = recommendedCamps[0].camp.genieMatch;
	for (let i:number = 3; i < recommendedCamps.length; i++) {
		//remove camps in rank 4-10 for genieMatch if their genieMatch is <90% rank1 camp
		if (recommendedCamps[i].camp.genieMatch < topGenieMatch * 0.9) {
			recommendedCamps.splice(i, recommendedCamps.length - i)
		};
	};
	recommendedCamps.sort(function(a,b) {
		if (a.camp.genie_score === undefined || a.camp.genie_score === null) {
			var scoreA:number = 0;
		} else {
			var scoreA:number = a.camp.genie_score;
		};
		if (b.camp.genie_score === undefined || b.camp.genie_score === null) {
			var scoreB:number = 0;
		} else {
			var scoreB:number = b.camp.genie_score;
		};
		if (Number.isNaN(scoreA)) scoreA = 0;
		if (Number.isNaN(scoreB)) scoreB = 0;
		return scoreB - scoreA;
	});
	recommendedCamps = recommendedCamps.slice(0,3);

	return recommendedCamps
};

async function add_camp_to_stop(trip:Trip_v2, stopID:string) {
    let resp:string;
    let respEl;
    let stop:Trip_Cluster_v2|null = null, legIndex:number, stopIndex:number;
    let gotStop:boolean = false;
    for (let i:number = 0; i < trip.legs.length; i++) {
        for (let j:number = 0; j < trip.legs[i].clusters.length; j++) {
            if (trip.legs[i].clusters[j].stopID == stopID) {
                stop = trip.legs[i].clusters[j];
                legIndex = i;
                stopIndex = j;
                gotStop = true;
                break;
            };
        };
        if (gotStop) break;
    };
    if (stop == null) return;

    if (stop.gotMatchScores !== true) {
        await get_genieMatches(stop).then(() => {
            stop.gotMatchScores = true;
        }).catch(e => {
            if (e.status != 200) {
                console.error(e);
            };

            throw new Error("No personalized recommendations");
        });
    };

    if (stop.altStops.map(a => a.camp.genieMatch).filter(a => a != null && a != undefined).length == 0) {
        throw new Error("No personalized recommendations");
    };

    let newStay = null;
    let recommendedCamps:Campground_Data[] = get_recommended_camps(stop);
    let campID:number = recommendedCamps[0].camp.campID;
    for (let i:number = 0; i < stop.altStops.length; i++) {
        if (stop.altStops[i].camp.campID == campID) {
            newStay = stop.altStops[i];
            let newStayIdx = i;
            break;
        };
    };
    if (newStay == null) {
        let resp:string = `Sorry, I'm not able to get personalized recommendations for ${stop.clusterTitle}`;
        respEl = $("<div>").addClass("message bot").html(resp);
        $("#copilot-msg-stream").append(respEl);

        return;
    };

    const addedStay = add_stay_to_stop(stop, campID);
    if (!stop.fromUserQuery) {
        const stopData = await handle_auto_lock({
            stop: stop,
            legIndex: legIndex,
            stopIndex: stopIndex
        });
        if (stopData == null) {
            throw new Error("Out of stops");
        }
        stop = stopData.stop;
        legIndex = stopData.legIndex;
        stopIndex = stopData.stopIndex;
    };
    send_addStayToStop(legIndex, stopIndex, campID, addedStay.s_date, addedStay.numNights);

    $("#stopPopout").find("#stayList").find(`#${campID}`).remove();
    remove_stay_pin(campID);

    if (parseInt($("#ol_map_popup_card").attr("campID")) == campID) {
        $("#ol_map_popup_card").find("[add-stay-to-stop]").remove();
    };
    if (parseInt($("#map-stay-mobile").find(".card").attr("campID")) == campID) {
        $("#map-stay-mobile").find(".card").find("[add-stay-to-stop]").remove();
    };

    resp = `For <strong>${stop.clusterTitle}</strong> I've added <strong>${newStay.camp.camp_name}</strong>`;
    respEl = $("<div>").addClass("message bot").html("<span>" + resp + "</span>");
    $("#copilot-msg-stream").append(respEl);

    return true;
};

async function copilot_add_camps_all_stops(trip:Trip_v2) {
    let resp;
    let respEl;

    resp = "I'll add personalized campgrounds to all your stops!";
    respEl = $("<div>").addClass("message bot").html(resp);
    $("#copilot-msg-stream").append(respEl);

    if (!window.featureFlags || !window.featureFlags.freemiumAccess) {
        window.featureFlags = await getFeatureFlags(featureFlagKeys);
    };
    const genieMatchLvl = window.featureFlags.freemiumAccess.genieMatch;
    let userLvl = parseInt(window.GAsubLevel);
    if (userLvl == undefined) userLvl = -1;

    //convert userLvl to 0, 1, 2 to match freemium flag
    if (userLvl < 0) {
        userLvl = 0;
    } else if (userLvl < 1) {
        userLvl = 1;
    } else {
        userLvl = 2;
    };

    if (userLvl < genieMatchLvl) {
        let resp:string = "Looks like you don't have access to personalized GenieMatches. ";
        if (genieMatchLvl == 2) {
            resp += "Subscribe for personalized recommendations!";
        } else {
            resp += "Create an account to get personalized recommendations!";
        };
        respEl = $("<div>").addClass("message bot").html(resp);
        $("#copilot-msg-stream").append(respEl);
        return;
    };

    let added_stop:boolean = false;

    const stop_IDs = trip.legs.map(leg => leg.clusters.map(stop => stop.stopID)).flat();

    for (let i:number = 0; i < stop_IDs.length; i++) {
        try {
            if (await add_camp_to_stop(window.tripPlannerCurrentTrip, stop_IDs[i])) {
                added_stop = true;
            };
        } catch (e) {
            if (e.message == "No personalized recommendations") {
                let resp:string = "I'm not able to get personalized recommendations for all your stops. Have you set preferences in settings?";
                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);
            } else if (e.message == "Out of stops") {
                let resp:string = "Looks like you've used all your stops. ";
                if (window.GAsubLevel == undefined) {
                    resp += "Sign in to your account to add more";
                } else {
                    resp += "Subscribe to add more";
                };
                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);
                return;
            };
            return;
        };
    };

    if (added_stop) {
        clearLayer(window.stayMarkerLayer);
        displayStayPins(window.tripPlannerCurrentTrip);
        init_stay_hover_listener();
        clear_highlightedMarker();
         getTripHTML(window.tripPlannerCurrentTrip).then(tripHTML => {
            window.tripPlannerCurrentTrip.stopListHTML = tripHTML;
            display_trip_html(window.tripPlannerCurrentTrip, false);

        }).catch(e => {
            console.error(e);
        });
        document.dispatchEvent(new CustomEvent("directionsUpdateNeeded"));
    };
};

function copilot_add_camp(copilot_resp:copilot_success_resp, trip:Trip_v2) {
    let respEl;

    const stopID = copilot_resp.arguments.stop_identifier;
    const stopData = get_stop_from_stopID(stopID, trip);
    if (stopData == null) return;
    const stop:Trip_Cluster_v2 = stopData.stop;
    const legIndex:number = stopData.legIndex;
    const stopIndex:number = stopData.stopIndex;

    let newStay:Campground_Data|null=null;
    let newStayIdx:number|null=null;

    if (stop.gotMatchScores !== true) {
		if (parseInt(window.GAsubLevel) > 0) {
			get_genieMatches(stop).then(() => {

				stop.gotMatchScores = true;

                let recommendedCamps:Campground_Data[] = get_recommended_camps(stop);
                let campID:number = recommendedCamps[0].camp.campID;
                for (let i:number = 0; i < stop.altStops.length; i++) {
                    if (stop.altStops[i].camp.campID == campID) {
                        newStay = stop.altStops[i];
                        newStayIdx = i;
                        break;
                    };
                };
                let resp:string = `I'd recommend <strong>${newStay.camp.camp_name}</strong> -`;

                // if (stop.fromUserQuery) {
                //     resp += `click <a href="#" add-stay-to-stop="" stopID="${stopID}" campid="${newStay.camp.campID}">Here</a> to add this campground`;
                //     resp += ` or click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
                // } else {
                //     resp += ` Click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
                // };
                resp += `click <a href="#" add-stay-to-stop="" stopID="${stopID}" campid="${newStay.camp.campID}">Here</a> to add this campground`;
                resp += ` or click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
                // $("#copilotGenieBubble").html(resp);

                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);

                respEl.find("[addstaybutton]").on("click", function() {
                    display_stop_popout(stopID, !stop.fromUserQuery, true);
                });
                document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"));
			}).catch(e => {
				if (e.status != 200) {
                    console.error(e);
                };
				$("#sortBy_tripPlanner option[value='genie_match']").prop("disabled", true);
				$("#recommendedCamps-needPref").show();

                let resp:string = "You can view your campground options & add one by clicking the '+'";
                resp += '</br></br>By the way, if you set preferences in settings I can recommend camps!';
                // $("#copilotGenieBubble").html(resp);
                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);
                display_stop_popout(stopID, !stop.fromUserQuery, true);
			});
            return;
		}
	} else if (parseInt(window.GAsubLevel) > 0) {
        let recommendedCamps:Campground_Data[] = get_recommended_camps(stop);
        let campID:number = recommendedCamps[0].camp.campID;
        for (let i:number = 0; i < stop.altStops.length; i++) {
            if (stop.altStops[i].camp.campID == campID) {
                newStay = stop.altStops[i];
                newStayIdx = i;
                break;
            };
        };
        let resp:string = `I'd recommend <strong>${newStay.camp.camp_name}</strong> -`;
        // if (stop.fromUserQuery) {
        //     resp += `click <a href="#" add-stay-to-stop="" stopID="${stopID}" campid="${newStay.camp.campID}">Here</a> to add this campground`;
        //     resp += ` or click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
        // } else {
        //     resp += ` Click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
        // };
        resp += `click <a href="#" add-stay-to-stop="" stopID="${stopID}" campid="${newStay.camp.campID}">Here</a> to add this campground`;
        resp += ` or click <a href="#" addstaybutton="" stopID="${stopID}">Here</a> to view other campgrounds`;
        // $("#copilotGenieBubble").html(resp);
        respEl = $("<div>").addClass("message bot").html(resp);
        $("#copilot-msg-stream").append(respEl);
        respEl.find("[addstaybutton]").on("click", function() {
            display_stop_popout(stopID, !stop.fromUserQuery, true);
        });
        document.getElementById("stopPopout").dispatchEvent(new CustomEvent("stays.displayed"));
        return;
    };

    let resp:string = "You can view your campground options & add one by clicking the '+'";
    resp += '</br></br>By the way, if you set preferences in settings I can recommend camps!';
    // $("#copilotGenieBubble").html(resp);
    respEl = $("<div>").addClass("message bot").html(resp);
    $("#copilot-msg-stream").append(respEl);
    display_stop_popout(stopID, !stop.fromUserQuery, true);
};

const copilot_functionality_desc = [
    "I can create new trips for you or edit your existing trip.</br>",
    "You can ask me to add new stops to your trip or to remove a stop - ",
    "try something like <a copilot_autofill='visit Miami' href='#'>visit Miami</a></br>",
    "I can help you add campgrounds or even suggest places to stay!</br>",
    "If you want help with itinerary ask something like <a copilot_autofill='I want places to hike on my trip' href='#'>I want places to hike on my trip</a></br>",
    "I can also help if you want to get a printout of your trip or to export it to your GPS!</br></br>",
    "If you want help adjusting the route of your trip, try things like ",
    "<a copilot_autofill='Avoid toll roads' href='#'>Avoid toll roads</a></br>"
].join("\n");

export function handle_copilot_resp(copilot_resp:copilot_success_resp|copilot_err_resp, trip:Trip_v2) {
    let respEl;
    if ("found_intent" in copilot_resp) {
        // $("#copilotGenieBubble").html(copilot_resp.message);
        respEl = $("<div>").addClass("message bot").html(copilot_resp.message);
        $("#copilot-msg-stream").append(respEl);
        return;
    };

    const stopID = copilot_resp.arguments.stop_identifier;
    const stopData = get_stop_from_stopID(stopID, trip);
    let stop:Trip_Cluster_v2;
    let legIndex:number;
    let stopIndex:number
    if (stopData != null) {
        stop= stopData.stop;
        legIndex = stopData.legIndex;
        stopIndex = stopData.stopIndex;
    };

    console.log(copilot_resp);

    switch(copilot_resp["name"]) {
        case "route_around_area":
            const area_query:string = copilot_resp.arguments.area_query;
            $("#copilot-msg-stream").append($("<div>").addClass("message bot").html(`Updating your route to avoid ${area_query}`));
            routing_avoid_area(area_query).catch(e => {
                $("#copilot-msg-stream").append($("<div>").addClass("message bot").html(`Sorry, it looks like I wasn't able to update your route to avoid ${area_query}`));
            });
            break;
        case "describe_functionality":
            // $("#copilotGenieBubble").html(copilot_functionality_desc);
            respEl = $("<div>").addClass("message bot").html(copilot_functionality_desc);
            $("#copilot-msg-stream").append(respEl);
            break;
        case "create_trip":
            if(window.tripPlannerCurrentTrip != undefined && window.tripPlannerCurrentTrip != null && window.tripPlannerCurrentTrip.legs != null) {
                let resp:string = "Looks like you want to create a new trip -- click</br>"
                resp += `<a href=/tripPlanner?genieJourney=${encodeURIComponent(copilot_resp.arguments.user_input)}&submit=true>Confirm</a>`;
                resp += "</br>to start planning your new trip!</br>";
                resp += "Keep in mind this will replace your current trip"
                // $("#copilotGenieBubble").html(resp);
                respEl = $("<div>").addClass("message bot").html(resp);
                $("#copilot-msg-stream").append(respEl);
            } else {
                if ($("#tripPlannerAllInOne textarea").length > 0) {
                    // $("#copilotGenieBubble").html("Creating your trip!")
                    respEl = $("<div>").addClass("message bot").html("Creating your trip!");
                    $("#copilot-msg-stream").append(respEl);
                    $("#tripPlannerAllInOne textarea").val(copilot_resp.arguments.user_input);
                    $("a[href='#magicSearch']").tab("show");
                    $("#tripPlannerAllInOne").trigger("submit");

                    if (document.getElementById("tripTab") != null) {
                        //user on mobile view so copilot offcanvas covers most of screen
                        setTimeout(function() {
                            $("#copilot").offcanvas("hide");
                        }, 1000);
                    };
                };
            };
            break;
        case "add_stops":
            if (window.tripPlannerCurrentTrip == null || window.tripPlannerCurrentTrip == undefined || window.tripPlannerCurrentTrip.legs == null) {
                // $("#copilotGenieBubble").html("Looks like you don't have a trip yet. Try creating a trip & then I can help you add more stops!");
                respEl = $("<div>").addClass("message bot").html("Looks like you don't have a trip yet. Try creating a trip & then I can help you add more stops!");
                $("#copilot-msg-stream").append(respEl);
                break;
            };
            copilot_add_stops(copilot_resp);
            break;
        case "remove_stop":
            if (stopData == null) return;

            // $("#copilotGenieBubble").html(`Removing ${stop.clusterTitle} from your trip`);
            respEl = $("<div>").addClass("message bot").html(`Removing ${stop.clusterTitle} from your trip`);
            $("#copilot-msg-stream").append(respEl);

            show_map_loadingIcon("Removing Stop");
            remove_stop(trip, legIndex, stopIndex, stopID).then(trip => {
                window.tripPlannerCurrentTrip = trip;
                hide_map_loadingIcon();
                if ($("#stopPopout").is(":visible") && $("#stopPopout").attr("stopid") == stopID) {
                    $("#stopPopout").addClass("d-none");
                    document.getElementById("stopPopout").dispatchEvent(new CustomEvent("element.hide",{bubbles:true,cancelable:true}));
                };

                document.dispatchEvent(new CustomEvent("trip.updated"));

                // $("#copilotGenieBubble").html(`${stop.clusterTitle} has been removed from your trip! Is there anything else I can help with?`);
                respEl = $("<div>").addClass("message bot").html(`${stop.clusterTitle} has been removed from your trip! Is there anything else I can help with?`);
                $("#copilot-msg-stream").append(respEl);
            }).catch(e => {
                if(e == "tripDeleted") {
                    window.location.reload();
                } else {
                    hide_map_loadingIcon();
                    console.error(e);
                };
            })
            break;
        case "print_trip":
            if ($("#printTrip").length > 0) {
                // $("#copilotGenieBubble").html("I'll create a pdf of your trip! If it doesn't open in a new tab make sure you allow popups");
                respEl = $("<div>").addClass("message bot").html("I'll create a pdf of your trip! If it doesn't open in a new tab make sure you allow popups");
                $("#copilot-msg-stream").append(respEl);
                $("#printTrip").trigger("click");
            } else {
                var msg = "Looks like you don't have access to trip exports."
                if (window.GAsubLevel != undefined) {
                    msg += " Subscribe for full access";
                } else {
                    msg += " Try signing up for an account";
                }
                // $("#copilotGenieBubble").html(msg);
                respEl = $("<div>").addClass("message bot").html(msg);
                $("#copilot-msg-stream").append(respEl);
            };
            break;
        case "gps_export":
            if ($("#downloadGPX").length > 0) {
                // $("#copilotGenieBubble").html("Here's a GPX file you can use with your GPS!");
                respEl = $("<div>").addClass("message bot").html("Here's a GPX file you can use with your GPS!");
                $("#copilot-msg-stream").append(respEl);
                $("#downloadGPX").trigger("click");
            } else {
                var msg = "Looks like you don't have access to trip exports."
                if (window.GAsubLevel != undefined) {
                    msg += " Subscribe for full access";
                } else {
                    msg += " Try signing up for an account";
                }
                // $("#copilotGenieBubble").html(msg);
                respEl = $("<div>").addClass("message bot").html(msg);
                $("#copilot-msg-stream").append(respEl);
            };
            break;
        case "spreadsheet_export":
            if ($("#downloadXLSX").length > 0) {
                // $("#copilotGenieBubble").html("Here's an Excel spreadsheet of your trip!");
                respEl = $("<div>").addClass("message bot").html("Here's an Excel spreadsheet of your trip!");
                $("#copilot-msg-stream").append(respEl);
                $("#downloadXLSX").trigger("click");
            } else {
                var msg = "Looks like you don't have access to trip exports."
                if (window.GAsubLevel != undefined) {
                    msg += " Subscribe for full access";
                } else {
                    msg += " Try signing up for an account";
                }
                // $("#copilotGenieBubble").html(msg);
                respEl = $("<div>").addClass("message bot").html(msg);
                $("#copilot-msg-stream").append(respEl);
            };
            break;
        case "recalculate":
            // $("#copilotGenieBubble").html("I'll go ahead and update your routing settings");
            respEl = $("<div>").addClass("message bot").html("I'll go ahead and update your routing settings");
            $("#copilot-msg-stream").append(respEl);
            copilot_handle_reroute(copilot_resp);
            break;
        case "add_campground":
            copilot_add_camp(copilot_resp, trip);
            break;
        case "genie_wishes":
            if ("stop_identifier" in copilot_resp.arguments) {
                if (stopData == null) return;
                $("#stopPopout").find('a[href="#wishes"]').tab("show");
                display_stop_popout(stopID, !stop.fromUserQuery, false);
                if ($("#stopWishesForm").find("button[type='submit']").length) {
                    $("#stopWishesForm").find("[whattodo]").val(copilot_resp.arguments.user_input);
                    $("#stopWishesForm").trigger("submit");
                    // $("#copilotGenieBubble").html("Creating your itinerary now!");
                    respEl = $("<div>").addClass("message bot").html("Creating your itinerary now!");
                    $("#copilot-msg-stream").append(respEl);
                } else {
                    // $("#copilotGenieBubble").html("Looks like you don't have access to whole trip GenieWishes. Can you specify a stop?");
                    respEl = $("<div>").addClass("message bot").html("Looks like you don't have access to whole trip GenieWishes. Can you specify a stop?");
                    $("#copilot-msg-stream").append(respEl);
                    return;
                };
            } else {
                $('a[data-bs-toggle="tab"][href="#wishesTab"]').tab("show");
                if ($("#getItineraryForm").find("button[type='submit']").length) {
                    $("#getItineraryForm").find("[whattodo]").val(copilot_resp.arguments.user_input);
                    $("#getItineraryForm").trigger("submit");
                    // $("#copilotGenieBubble").html("Creating your itinerary now!");
                    respEl = $("<div>").addClass("message bot").html("Creating your itinerary now!");
                    $("#copilot-msg-stream").append(respEl);
                } else {
                    // $("#copilotGenieBubble").html("Looks like you don't have access to whole trip GenieWishes. Can you specify a stop?");
                    respEl = $("<div>").addClass("message bot").html("Looks like you don't have access to whole trip GenieWishes. Can you specify a stop?");
                    $("#copilot-msg-stream").append(respEl);
                    return;
                };
            }
            break;
        case "rent_rv":
            if (stopData == null) return;
            display_stop_popout(stopID, !stop.fromUserQuery, true);
            $("#stopPopout").find('[data-bs-toggle="tab"][href="#staysTab_rvs"]').tab("show");
            // $("#copilotGenieBubble").html(`I've opened our RV rental search for you at ${stop.clusterTitle} so you can find an RV!`);
            respEl = $("<div>").addClass("message bot").html(`I've opened our RV rental search for you at ${stop.clusterTitle} so you can find an RV!`);
            $("#copilot-msg-stream").append(respEl);
            break;
        case "add_all_campgrounds":
            copilot_add_camps_all_stops(trip)
            break;
        case "get_pois_on_route":
            let to_trigger:JQuery<HTMLElement>|undefined = undefined;
            switch (copilot_resp.arguments.poi_type) {
                case 'fuel':
                    to_trigger = $("input#onRoute-25-26-27-30");
                    break;
                case 'walmart':
                    to_trigger = $("input#onRoute-33");
                    break;
                case 'loves':
                    to_trigger = $("input#onRoute-26");
                    break;
                case 'pilot_flying_j':
                    to_trigger = $("input#onRoute-25")
                    break;
                case 'ta_travel_center':
                    to_trigger = $("input#onRoute-27")
                    break;
                case 'bucees':
                    to_trigger = $("input#onRoute-30")
                    break;
                case 'dump_stations':
                    to_trigger = $("input#onRoute-35");
                    break;
                case 'OpenRoads':
                    to_trigger = $("input#onRoute-36");
                    break;
                default:
                    break;
            };
            if (to_trigger != undefined) {
                if (!to_trigger.prop("checked")) {
                    to_trigger.trigger("click");
                };
                respEl = $("<div>").addClass("message bot").html(`I've displayed POIs along your route for you!`);
                $("#copilot-msg-stream").append(respEl);
            } else {
                respEl = $("<div>").addClass("message bot").html("Looks like we don't have that option yet. Try searching for another POI type");
                $("#copilot-msg-stream").append(respEl);
            };
            break;
        default:
            break;
    };
};